import { render } from "./FormBolum.vue?vue&type=template&id=8d37fa6e"
import script from "./FormBolum.vue?vue&type=script&lang=js"
export * from "./FormBolum.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__